import * as React from "react";
import { forwardRef } from "react";
const SvgX = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 11, height: 11, viewBox: "0 0 11 11", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M3.394 5.493L0 2.086 2.086 0l3.407 3.394L8.901 0 11 2.086 7.592 5.493 11 8.901 8.9 11 5.494 7.592 2.086 11 0 8.9z" }));
const ForwardRef = forwardRef(SvgX);
export default ForwardRef;
